import {Image} from 'antd'
import moment from 'moment'
import DialogCustom from 'src/components/elements/DialogCustom/DialogCustom'
import {BODY_PARTS_OPTIONS} from 'src/constants/constants'

type ImageDialogProps = {
  record: Record<string, any>,
  onClose: () => void;
};

const ImageDialog: React.FC<ImageDialogProps> = ({record, onClose}) => {
  const title = `${BODY_PARTS_OPTIONS.find(option => option.value === record?.bodyPart)?.label || record?.bodyPart || ''} - ${moment(record?.date).format('DD MMM YYYY')}`
  const src = `psp-backend/images/download/${record.file}`

  const body = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxHeight: '70vh',
        overflow: 'hidden'
      }}
    >
      <Image
        alt={title}
        preview={{
          zIndex: 9999
        }}
        src={src}
      />
    </div>
  )

  return (
    <DialogCustom
      body={body}
      maxWidth='lg'
      onClose={onClose}
      title={{text: title, format: false}}
    />
  )
}

export default ImageDialog
